import { css } from '@/styled-system/css';

export const hdpPpcLinkContainer = css({
  fontSize: 'sm',
  lineHeight: 'sm',
  md: {
    fontSize: 'md',
    lineHeight: 'md',
  },
});
